import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AutoLogin() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginPortal } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.post(`${API}/api/portal/token-login`, { token });
        if (cancelled) return;
        loginPortal(data.token);
        navigate("/studio", { replace: true });
      } catch (e) {
        if (!cancelled) setError("This design link is invalid or has expired.");
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F6F0] px-6" data-testid="auto-login-page">
      {error ? (
        <div className="max-w-sm text-center" data-testid="auto-login-error">
          <AlertTriangle className="h-8 w-8 text-[#B0413E] mx-auto mb-3" />
          <p className="text-[#1A1918] font-serif text-xl mb-2">Link unavailable</p>
          <p className="text-sm text-[#5C5852] mb-5">{error}</p>
          <Link to="/" className="text-[#C85A32] font-mono text-xs uppercase tracking-widest hover:underline">Go to the design portal</Link>
        </div>
      ) : (
        <div className="text-center text-[#5C5852]">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-3 text-[#C85A32]" />
          <p className="font-mono text-xs uppercase tracking-widest">Opening your design studio…</p>
        </div>
      )}
    </div>
  );
}
